import React from "react";
import { womensCouture, girlsCouture } from "../data/mockData";
import { Link } from "react-router-dom";

export const Collections = () => {

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-[60vh] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1568251188392-ae32f898cb3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwY291dHVyZXxlbnwwfHx8fDE3NzI0NjUwNTF8MA&ixlib=rb-4.1.0&q=85"
          alt="MIA Atelier Collections"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div className="max-w-3xl text-white">
            <h1 className="text-5xl md:text-7xl mb-6 font-light" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}>
              Collections
            </h1>
            <p className="text-base md:text-xl tracking-wide leading-loose font-light" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
              Couture for mothers and daughters
            </p>
          </div>
        </div>
      </section>

      {/* Collection Grid - Editorial Sections */}
      <section className="py-48 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          {/* Women's Couture Section */}
          <div className="mb-40">
            <h2 className="text-3xl md:text-4xl mb-20 text-center font-light tracking-wide" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}>
              The Women's Couture Collection
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
              {womensCouture.map((item) => (
                <div
                  key={item.id}
                  className="group"
                >
                  <div className="relative overflow-hidden aspect-[3/4] mb-6">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
                    />
                  </div>
                  <div className="text-center space-y-4">
                    <h3 className="text-xl font-light" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}>
                      {item.name}
                    </h3>
                    <p className="text-[#8B7D6B] text-sm font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      {item.description}
                    </p>
                    
                    {/* Fit Note */}
                    {item.fitNote && (
                      <p className="text-[#A39383] text-xs font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {item.fitNote}
                      </p>
                    )}
                    
                    {/* Pricing - USD primary, NGN secondary */}
                    <div className="space-y-1">
                      <p className="text-[#2C2C2C] tracking-wide text-base font-light" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {item.price}
                      </p>
                      <p className="text-[#B5A89A] text-xs font-light" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {item.priceNGN}
                      </p>
                    </div>
                    
                    {/* Inventory Communication */}
                    <p className="text-[#B5A89A] text-xs font-light leading-relaxed pt-3" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Produced in limited quantities.
                    </p>
                    
                    {/* Commerce Actions */}
                    <div className="pt-6 space-y-3">
                      <button
                        className="w-full px-8 py-3 bg-[#E8DCC8]/85 text-[#2C2C2C] tracking-[0.2em] font-normal text-xs uppercase hover:bg-[#E8DCC8] transition-all duration-500 ease-out border border-[#E8DCC8]/30"
                        style={{ fontFamily: "'Montserrat', sans-serif" }}
                      >
                        Add to Cart
                      </button>
                      <Link
                        to="/shop"
                        className="block text-[#A39383] hover:text-[#2C2C2C] text-xs tracking-wide transition-colors duration-500"
                        style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                      >
                        Request Private Consultation
                      </Link>
                      
                      {/* Fulfillment Note */}
                      <p className="text-[#C4B5A0] text-xs font-light leading-relaxed pt-4" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        Please allow 5–10 business days for dispatch.
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Girls' Couture Section */}
          <div>
            <h2 className="text-3xl md:text-4xl mb-20 text-center font-light tracking-wide" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}>
              Girls' Couture
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
              {girlsCouture.map((item) => (
                <div
                  key={item.id}
                  className="group"
                >
                  <div className="relative overflow-hidden aspect-[3/4] mb-6">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
                    />
                  </div>
                  <div className="text-center space-y-4">
                    <h3 className="text-xl font-light" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}>
                      {item.name}
                    </h3>
                    <p className="text-[#8B7D6B] text-sm font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      {item.description}
                    </p>
                    
                    {/* Fit Note */}
                    {item.fitNote && (
                      <p className="text-[#A39383] text-xs font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {item.fitNote}
                      </p>
                    )}
                    
                    {/* Pricing - USD primary, NGN secondary */}
                    <div className="space-y-1">
                      <p className="text-[#2C2C2C] tracking-wide text-base font-light" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {item.price}
                      </p>
                      <p className="text-[#B5A89A] text-xs font-light" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {item.priceNGN}
                      </p>
                    </div>
                    
                    {/* Inventory Communication */}
                    <p className="text-[#B5A89A] text-xs font-light leading-relaxed pt-3" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Produced in limited quantities.
                    </p>
                    
                    {/* Commerce Actions */}
                    <div className="pt-6 space-y-3">
                      <button
                        className="w-full px-8 py-3 bg-[#E8DCC8]/85 text-[#2C2C2C] tracking-[0.2em] font-normal text-xs uppercase hover:bg-[#E8DCC8] transition-all duration-500 ease-out border border-[#E8DCC8]/30"
                        style={{ fontFamily: "'Montserrat', sans-serif" }}
                      >
                        Add to Cart
                      </button>
                      <Link
                        to="/shop"
                        className="block text-[#A39383] hover:text-[#2C2C2C] text-xs tracking-wide transition-colors duration-500"
                        style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                      >
                        Request Private Consultation
                      </Link>
                      
                      {/* Fulfillment Note */}
                      <p className="text-[#C4B5A0] text-xs font-light leading-relaxed pt-4" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        Please allow 5–10 business days for dispatch.
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
